import { useDispatch as useUntypedDispatch } from "react-redux";

import type { RootDispatch } from "../index";

const useDispatch = () => useUntypedDispatch<RootDispatch>();

export default useDispatch;
